import Vue from 'vue'
import Router from 'vue-router'
import App from '../src/App.vue';
import home from './views/home/home.vue'
import reg from './views/reg/reg.vue'
import charge from './components/charge/charge.vue'
import guardianship from './views/guardianship/guardianship.vue'
import dispute from './views/dispute/dispute.vue'
import addicted from './views/addicted/addicted.vue'
import toGame from './page/game.vue'
import parentcustody from './views/parentcustody/parentcustody.vue'
import lostinself from './views/lostinself/lostinself.vue'
import aboutus from './views/aboutus/aboutus.vue'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    { path: '/', redirect: { name: 'home' } },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/charge',
      name: 'charge',
      component: charge
    },
    {
      path: '/reg',
      name: 'reg',
      component: reg
    },
    {
      path: '/guardianship',
      name: 'guardianship',
      component: guardianship
    },
    {
      path: '/dispute',
      name: 'dispute',
      component: dispute
    },
    {
      path: '/addicted',
      name: 'addicted',
      component: addicted
    },
    {
      path: '/toGame',
      name: 'toGame',
      component: toGame
    },
    {
      path:'/parentcustody',
      name:'parentcustody',
      component:parentcustody
    },
    {
      path:'/lostinself',
      name:'lostinself',
      component:lostinself
    },
    {
      path:'/aboutus',
        name:'aboutus',
      component:aboutus
    }
  ]
})
